import React, { useState, useMemo, useRef, useEffect } from 'react'
import { ITEM_HEIGHT } from '../constants'
import { AgGridReact } from 'ag-grid-react'
import * as MPActions from './actions'
import { getStage, validate } from './actions/helper'
import { CheckCircle, ErrorRounded, Link } from '@material-ui/icons'
import _ from 'lodash'
// import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { actions } from '../listView.reducer'
import { ListViewStateContext, ListViewDispatchContext } from '../listView.context'
import { DEBOUNCE_TIME } from '../constants'
import Status from './Status'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import { massProcessingApi } from '@atheneum/api'
import {
  Tooltip as TooltipMUI,
  IconButton,
  CircularProgress,
  FormControl,
  TextField,
  Chip, 
  // Avatar,
} from '@material-ui/core'
import { Delete } from '@material-ui/icons'
import { stores } from '../../stores'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Tooltip from '../../components/Tooltip/Tooltip'
import LinkedInIcon from '../../components/icons/LinkedInIcon'
import LiePinIcon from '../../components/icons/LiePinIcon'
import ErrorBoundary from '../../components/errorBoundary'

const updateFieldDebounced = _.debounce(
  massProcessingApi.updateField,
  DEBOUNCE_TIME
)

const RenderStatus = props => {
  return <Status {...props} />
}

const RenderCheckbox = ({ item, field, data, isDisabled, onChange }) => (
  <div
    className="mass-processing--field"
    title={`itemId: ${item.id}, column: ${field.name}`}
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
      height: ITEM_HEIGHT
    }}>
    {item.id !== 'new' && field !== 'checked' && (
      <input
        disabled={isDisabled}
        style={{
          flexGrow: 0,
          background: `${isDisabled ? '#ccc' : 'white'}`,
          cursor: `${isDisabled ? 'initial' : 'pointer'}`
        }}
        autoComplete="off"
        onChange={() => onChange(!data, null, true)}
        type="checkbox"
        checked={data}
      />
    )}
  </div>
)

const RenderActions = ({ item, dispatch, state }) => {
  const [removingItem, setRemovingItem] = useState(false)
  const [addingNewItem, setAddingNewItem] = useState(false)
  return (
    <div
      className={`${
        item.id !== 'new' ? 'mass-processing--field' : ''
      } mass-processing--field-actions`}>
      {item.id === 'new' ? (
        <>
          {!addingNewItem ? (
            <AddCircleOutlineIcon
              title="Add Expert"
              className="al-addNewItem"
              onClick={async () => {
                setAddingNewItem(true)
                dispatch({ type: actions.ADD_ITEM })
                const item = await massProcessingApi.createItem(
                  state.listId,
                  state.newItem.data
                )
                dispatch({ type: actions.ADD_ITEM_DONE, payload: item })
                setAddingNewItem(false)
              }}
            />
          ) : (
            <CircularProgress
              style={{ color: '#429bdc', width: '30px', height: '30px' }}
            />
          )}
        </>
      ) : (
        <TooltipMUI placement="left-end" title="Remove record from this list">
          <IconButton
            size="small"
            onClick={async () => {
              setRemovingItem(true)
              await massProcessingApi.deleteItem(item.id)
              dispatch({ type: actions.REMOVE_ITEM_DONE, payload: item.id })
              setRemovingItem(false)
            }}>
            {removingItem ? (
              <CircularProgress
                style={{ color: '#429bdc', width: '20px', height: '20px' }}
              />
            ) : (
              <Delete fontSize="small" />
            )}
          </IconButton>
        </TooltipMUI>
      )}
    </div>
  )
}

function RenderStaticData({ item, field, dispatch, data }) {
  const staticData = stores.staticData.staticData
  return (
    <FormControl style={{ width: '100%' }}>
      <select
        className={'mpRowSelect'}
        style={
          item.id === 'new'
            ? {
                margin: '10px 0px 10px 0',
                border: ' 1px solid #0000001F',
                outline: 'none',
                borderRadius: '4px'
              }
            : {}
        }
        placeholder={'Industry'}
        onChange={async e => {
          const value = e.target.value

          dispatch({
            type: actions.UPDATE_FIELD,
            payload: {
              id: item.id,
              field,
              value
            }
          })

          if (item.id !== 'new') {
            await updateFieldDebounced({
              id: item.id,
              key: field.name,
              value
            })
          }
        }}
        value={data}>
        <option default disabled={data} selected={!data}>
          {field.title}
        </option>
        {(staticData[field.dataType] || []).map(i => {
          return (
            <option
              style={{ padding: 10 }}
              disabled={data.selected === false || i.name === 'Other'}
              value={i.id}
              key={i.id}
              selected={data === i.id}>
              {i.name}
            </option>
          )
        })}
      </select>
    </FormControl>
  )
}

const RenderInputArray = props => {
  return (
    <Autocomplete
      multiple
      disableClearable
      freeSolo
      autoSelect
      size="small"
      value={props.data}
      style={{
        position: 'relative'
      }}
      options={[]}
      onChange={(e, value) => {
        props.onChange(value, true, true)
      }}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Tooltip key={index} tooltip={option}>
            <Chip
              color="primary"
              key={option}
              label={option}
              size="small"
              style={{
                height: '24px',
                backgroundColor: '#429ADC'
              }}
              {...getTagProps({ index })}
            />
          </Tooltip>
        ))
      }
      renderInput={params => {
        params.InputProps.disableUnderline = true
        return (
          <TextField
          disabled={true}
            autoFocus={props.autofocus}
            onFocus={(event) =>{
              if(!props.autofocus){
                event.target.blur()
              }
            }
            }
            {...params}
            variant="standard"
          />
        )
      }}
    />
  )
}

const RenderSelectableInputArray = props => (
  <Autocomplete
    multiple
    autoSelect
    disableClearable
    freeSolo
    size="small"
    value={props.data}
    style={{
      position: 'relative'
    }}
    options={[]}
    onChange={(e, value) => {
      return props.onChange(
        value.map(item =>
          typeof item === 'object' ? item : { email: item, selected: true }
        ),
        true,
        true
      )
    }}
    renderTags={(value, getTagProps) =>
      value.map((option, index) => (
        <Tooltip key={index} tooltip={option.email}>
          <Chip
            variant={option.selected ? undefined : 'outlined'}
            color="primary"
            key={index}
            label={option.email}
            // avatar={index === 0? <Avatar style={{
            //   backgroundColor:'#429ADC'
            // }}><AccountCircleIcon /></Avatar> : null}
            style={{
              height: '24px',
              backgroundColor: option.selected ? '#429ADC' : undefined,
              border: !option.selected ? '1px solid #429ADC' : undefined,
              color: !option.selected ? '#429ADC' : undefined
            }}
            size="small"
            // To be uncommented when preffered email functionality is implemented
            // deleteIcon={
            //   <>
            //     {props.data[index].private ? (
            //       <TooltipMUI key={index} title="Private Email">
            //       <PersonOutline
            //         onClick={e => {
            //           e.stopPropagation()
            //           props.data[index].private = false
            //           props.onChange(props.data, true, true)
            //         }}
            //       /></TooltipMUI>
            //     ) : (
            //       <TooltipMUI key={index} title="Work Email">
            //       <WorkOffOutlined
            //         onClick={e => {
            //           props.data[index].private = true
            //           props.onChange(props.data, true, true)
            //           e.stopPropagation()
            //         }}
            //       />
            //       </TooltipMUI>
            //     )}
            //     <Cancel
            //       onClick={e => {
            //         e.stopPropagation()
            //       }}
            //     />
            //   </>
            // }
            {...getTagProps({ index })}
            onClick={() => {
              props.data[index].selected = !props.data[index].selected
              props.onChange(props.data, true, true)
              return null
            }}
          />
        </Tooltip>
      ))
    }
    renderInput={params => {
      params.InputProps.disableUnderline = true
      return (
        <TextField
          {...params}
          autoFocus={props.autofocus}
          onFocus={(event) =>{
            if(!props.autofocus){
              event.target.blur()
            }
          }
          }
          variant="standard"
        />
      )
    }}
  />
)

const RenderValidation = ({ state, item }) => {
  if (item.id === 'new') return null // Don't show on bottom input row
  const validation = calculateValidation(item, state)
  const sherlock = isSherlockAllowed(item, state.massAction?.name)
  return (
    <div className="mass-processing--field mass-processing--field-actions">
      <TooltipMUI
        title={
          <>
            {validation && (
              <>
                Current action on this record is
                <span
                  style={{
                    color:
                      validation.isValid && sherlock.allowed
                        ? 'lightgreen'
                        : 'lightcoral'
                  }}>
                  {validation.isValid && sherlock.allowed
                    ? 'allowed'
                    : 'not allowed'}
                </span>
                <ul>
                  {validation.details
                    .filter(e => !e.state)
                    .map((e, i) => (
                      <li
                        key={i}
                        style={{
                          color: 'lightcoral'
                        }}>
                        <span style={{ color: 'lightcoral' }}>{e.desc}</span>
                      </li>
                    ))}
                </ul>
              </>
            )}
            {!sherlock.allowed && (
              <DisplaySherlockStatus
                itemId={item.id}
                status={item.data?.sherlock}
                action={state.massAction}
              />
            )}
          </>
        }>
        <div
          style={{
            cursor: 'pointer',
            position: 'relative',
            top: '10px'
          }}>
          {(!validation || validation?.isValid) &&
          sherlock.allowed &&
          sherlock.success ? (
            <CheckCircle className="green-text" />
          ) : (
            <ErrorRounded className="red-text" />
          )}
        </div>
      </TooltipMUI>
    </div>
  )
}

function calculateValidation(item, state) {
  const stage = getStage(state, MPActions)
  if (!stage) return null
  const validation = validate(item, stage.validators)
  return validation
}

function DisplaySherlockStatus({ status: sherlockStatus, itemId, action }) {
  const status = action?.name
    ? sherlockStatus[action.name === 'email' ? 'consultation' : action.name]
    : sherlockStatus['general']

  if (itemId === 'new') {
    return null
  } else if (!status) {
    return 'Checking DNC status in Sherlock'
  } else if (status.failed) {
    return 'An issue occurred while trying to get DNC status.'
  } else if (status?.allowed) {
    return 'Contacting expert is allowed.'
  } else {
    return status.display_reason || 'Contacting not allowed'
  }
}

function isSherlockAllowed(item, action) {
  if (action === 'copy')
    return {
      allowed: true,
      success: true
    }
  const types = {
    email: 'consultation',
    survey: 'survey',
    copy: 'general'
  }

  const type = types[action] || 'general'

  return {
    allowed: item.data?.sherlock?.[type]?.allowed || false,
    success: item.data?.sherlock?.success
  }
}

/**
 * suppress keyboard navigation for ag grid
 */
const suppressNavigation = (params, gridRef, fields) => {
  const event = params.event
  const key = event.key
  const keysToSuppress = ['Enter', 'Tab']

  const suppress = keysToSuppress.some(function(suppressedKey) {
    if (key === 'Tab') {
      const index = fields.findIndex(x => x.name === params.column.colId)
      if (index) {
        setTimeout(() => {
          gridRef.current.api.startEditingCell({
            // The row index of the row to start editing
            rowIndex: params.node.rowIndex,
            // The column key of the row to start editing
            colKey: fields[index + 1].name
          })
        }, 200)
      }
    }
    return suppressedKey === key || key.toUpperCase() === suppressedKey
  })
  return suppress && gridRef.current.api.getEditingCells().length
}

function GridCellRenderer(
  field,
  isDisabled,
  emailLoaded,
  setEmailLoaded,
  gridRef,
  editMode
) {
  const dispatch = React.useContext(ListViewDispatchContext)
  field = { ...field, name: field.column.colId }
  if (
    field.data?.formatted?.emails &&
    field.data?.formatted?.emails.length &&
    (typeof field.data.data.formatted?.emails[0] === 'string' || !emailLoaded)
  ) {
    if(!field.data.data.formatted){
      field.data.data.formatted = field.data.formatted
    }else{
      field.data.data.formatted.emails = field.data.formatted?.emails
    }
    setEmailLoaded(true)
  }
  const row = {
    item: field.data,
    data: _.get(field.data.data, field.colDef.field, ''),
    field,
    isDisabled,
    dispatch: React.useContext(ListViewDispatchContext),
    state: {},
    gridRef,
    autofocus: editMode ? true : false,
    editMode,
    onChange: async (value, save, updateState) => {
      if (updateState) {
        setTimeout(() => {
          row.data = value
          gridRef.current.api.stopEditing()
          gridRef.current.api.refreshCells({
            force: true,
            rowNodes: [
              gridRef.current.api.getDisplayedRowAtIndex(field.rowIndex)
            ],
            columns: [field.name]
          })
        })
        dispatch({
          type: actions.UPDATE_FIELD,
          payload: {
            id: field.data.id,
            field,
            value
          }
        })
      }
      if (save) {
        await updateFieldDebounced({
          id: field.data.id,
          key: field.name,
          value
        })
      }
    }
  }
  let component
  switch (field.colDef.type) {
    case 'status':
      component = <RenderStatus {...row} />
      break
    case 'checkbox':
      component = <RenderCheckbox {...row} />
      break
    case 'actions':
      component = <RenderActions {...row} />
      break
    case 'validation':
      component = <RenderValidation {...row} />
      break
    case 'staticData':
      component = <RenderStaticData {...row} />
      break
    case 'inputArray':
      if (field.colDef.field === 'formatted.emails') {
        row.data = row.data.filter(x => x)
        component = <RenderSelectableInputArray {...row} />
        break
      }
      component = <RenderInputArray {...row} />
      break
    default:
      return null
  }
  return <ErrorBoundary>{component}</ErrorBoundary>
}

export default function RenderList({ items, syncItem, isDisabled }) {
  const state = React.useContext(ListViewStateContext)
  const [emailLoaded, setEmailLoaded] = useState(false)
  const [editMode, setEditMode] = useState(false)
  const [cellWidth, setCellWidth] = useState(200)
  const gridRef = useRef()
  const dispatch = React.useContext(ListViewDispatchContext)
  const columnDefs = useMemo(
    () =>
      state.fields?.map(field => {
        return {
          valueGetter: params => {
            return getFieldValue(params, field.type)
          },
          valueSetter: params => {
            updateFieldDebounced({
              id: params.data.id,
              key: field.name,
              value: params.newValue
            })
            _.set(params.data.data, field.name, params.newValue)
            return true
          },
          field: field.name,
          headerTooltip: field.title,
          tooltipValueGetter: params =>
            field.name === 'status' ? null : params.data.data[field.name],
          headerName: field.title,
          type: field.type,
          filter:
            field.type === 'checkbox' ||
            field.type === 'validation' ||
            field.type === 'actions'
              ? false
              : true,
          width: field.width === 250 ? null : field.width,
          ...(field.type === 'status' && {
            filterParams: {
              valueGetter: params => {
                return params.data?.data?.status?.description
              }
            }
          }),
          ...(field.type !== 'input' && {
            cellRenderer: field =>
              GridCellRenderer(
                field,
                isDisabled,
                emailLoaded,
                setEmailLoaded,
                gridRef
              ),
            editable: false
          }),
          ...((field.name === 'surveyUUID') && {
            editable: false
          }),
          ...(field.type === 'inputArray' && {
            cellEditor: field =>
              GridCellRenderer(
                field,
                isDisabled,
                emailLoaded,
                setEmailLoaded,
                gridRef,
                true
              ),
            editable: true,
            suppressKeyboardEvent: params => suppressNavigation(params, gridRef, state.fields)
          }),
          cellStyle: params => {
            if (field.type === 'status' && params.data?.data?.status) {
              switch (params.data.data.status.status) {
                case 'EMAIL_SENT':
                  return { backgroundColor: 'rgba(185,246,202,.4)' }
                case 'COMPLETE':
                  return { backgroundColor: 'rgba(185,246,202,.4)' }
                case 'EMAIL_DELIVERY':
                  return { backgroundColor: 'rgba(185,246,202,.4)' }
                case 'SURVEY_QUALIFIED':
                  return { backgroundColor: 'rgba(185,246,202,.4)' }
                case 'EMAIL_OPEN':
                  return { backgroundColor: 'rgba(185,246,202,.4)' }
                case 'INTERESTED':
                  return { backgroundColor: 'rgba(185,246,202,.4)' }
                case 'SURVEY_TERMINATED':
                  return { backgroundColor: 'rgba(255,128,171,.4)' }
                case 'EMAIL_ERROR':
                  return { backgroundColor: 'rgba(255,128,171,.4)' }
                case 'UNSUBSCRIBED':
                  return { backgroundColor: 'rgba(255,128,171,.4)' }
                case 'NOT_INTERESTED':
                  return { backgroundColor: 'rgba(255,128,171,.4)' }
                case 'EMAIL_FAIL':
                  return { backgroundColor: 'rgba(255,128,171,.4)' }
                default:
                  return {height: '100%'}
              }
            }
            return {height: '100%'}
          }
        }
      }),
    [state.fields, isDisabled, emailLoaded]
  )

  const columnTypes = useMemo(() => {
    return {
      actions: {},
      status: {},
      input: {},
      validation: {},
      checkbox: {},
      inputArray: {}
    }
  }, [])
  // anything specified in defaultColDef gets applied to all columns
  const defaultColDef = useMemo(
    () => ({
      // set filtering on for all columns
      filter: true,
      // set sorting on for all columns
      sortable: true,
      suppressCellFocus: true,
      resizable: true,
      editable: true,
      cellRenderer: row => {
        const isInputLink = new RegExp(
          // eslint-disable-next-line no-useless-escape
          /(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/
        )
        const value = getFieldValue(row) || ''
        return (
          <>
            {isInputLink.test(value) ? (
              <a
                style={{ position: 'relative', top: '7px' }}
                href={value}
                rel="noopener noreferrer"
                target="_blank">
                {_.includes(value, 'linkedin') ? (
                  <LinkedInIcon></LinkedInIcon>
                ) : (
                  <>
                    {_.includes(value, 'liepin') ? (
                      <LiePinIcon></LiePinIcon>
                    ) : (
                      <Link></Link>
                    )}
                  </>
                )}
              </a>
            ) : (
              value
            )}
          </>
        )
      }
    }),
    []
  )
  const getRowId = params => params.data.id
  const resizeColumns = params => gridRef.current.api.sizeColumnsToFit()

  const setEditWidth = params => {
    if(params.column.colId === 'formatted.emails' || params.column.colId === 'formatted.phones'){
      setEditMode(!editMode)
      if(!editMode){
        setCellWidth(params.column.actualWidth)
        gridRef.current.columnApi.setColumnWidth(params.column.colId, params.column.colId === 'formatted.emails'? 900 : 400)
      }else{
        gridRef.current.columnApi.setColumnWidth(params.column.colId, cellWidth)
      }
    }
  }

  const getMainMenuItems = params => {
    let menuItems = [
      ...params.defaultItems,
      {
        name: 'Delete Column',
        action: () => {
          massProcessingApi.updateList({
            id: state.listId,
            data: {
              fields: [
                ...state._fields.filter(
                  field => field.name !== params.column.colId
                )
              ]
            }
          })
          dispatch({
            type: actions.REMOVE_COLUMN,
            payload: params.column.colId
          })
        }
      }
    ]
    return menuItems
  }

  /**
   * Updating grid status cell when we recieve a status sync item
   */
  useEffect(() => {
    if(syncItem.field === 'data.status'){
      setTimeout(() => {
        gridRef.current.api.refreshCells({
          force: true,
          rowNodes: [
            gridRef.current.api.getDisplayedRowAtIndex(items.findIndex(x => x.id === syncItem.item.id))
          ],
          columns: ['status', 'surveyUUID']
        })
      })
    }
  }, [items, syncItem])
  
  return (
    <>
      <link
        href="https://fonts.googleapis.com/css?family=Roboto"
        rel="stylesheet"
      />
      <div
        className="ag-theme-material"
        style={{ width: '100%', height: '100%' }}>
        <AgGridReact
          ref={gridRef}
          rowHeight={65}
          getMainMenuItems={getMainMenuItems}
          stopEditingWhenCellsLoseFocus={true}
          onFirstDataRendered={resizeColumns}
          onCellEditingStarted={setEditWidth}
          onCellEditingStopped={setEditWidth}
          onFilterChanged={event => {
            let rowIds = []
            event.api.forEachNodeAfterFilter(node => rowIds.push(node.data.id))
            dispatch({
              type: actions.GRID_FILTER_APPLIED,
              payload: rowIds
            })
          }}
          rowSelection={'multiple'}
          getRowId={getRowId}
          defaultColDef={defaultColDef}
          rowData={items}
          columnTypes={columnTypes}
          tooltipShowDelay={500}
          columnDefs={columnDefs}></AgGridReact>
      </div>
    </>
  )
}

 /**
   * parses and returns nested object value for ag grid
   */
  function getFieldValue(params, type) {
    const fieldName = params.column.colId
      .split('.')
      .map((fieldName, index) => {
        if (index === 0) {
          return fieldName
        }
        return isNaN(fieldName) ? '.' + fieldName : `[${fieldName}]`
      })
      .join('')
      const field = _.get(params.data.data, fieldName)
      if(fieldName === 'formatted.emails'){
        return field.map(i => i?.email)
      }
      if(fieldName === 'status'){
        return field?.description
      }
    return (type !== 'inputArray' && field &&  typeof field === 'object') ? field.toString() : field
  }
